import { z } from "zod";

const nullableNumber = z.union([z.number(), z.string()]).nullable().default(null);
const nullableString = z.string().nullable().default(null);
const nullableBoolean = z.union([z.boolean(), z.string()]).nullable().default(null);
const nullableStringToEmpty = z
	.string()
	.nullable()
	.default(null)
	.transform((val) => val ?? "");

export const rawDataItemSchema = z.object({
	utcDateTime: z.string(),
	barcode: z.string().optional(),
	cartonsProduced: z.number().default(0),
	customAttributes: z.record(z.string(), z.string().nullable()),
	flapsDown: z.string(),
	flapsDownBandUsed: z.string(),
	succeeded: z.boolean(),

	articleName: nullableString,
	alias: nullableString,
	tiled: nullableBoolean,
	designId: nullableString,
	designName: nullableString,
	zFoldName: nullableString,
	zFoldWidth: nullableNumber,
	zFoldFlute: nullableString,
	zFoldBrand: nullableNumber,
	boxLength: nullableNumber,
	boxWidth: nullableNumber,
	boxHeight: nullableNumber,
	zFoldUsedLength: nullableNumber,
	zFoldUsedWidth: nullableNumber,
	machine: nullableString,
	totalZFoldArea: nullableNumber,
	cartonArea: nullableNumber,
	areaPerBox: nullableNumber,
	trimArea: nullableNumber,
	trimPercentage: nullableNumber,
	producedOptimally: nullableBoolean,
	cycleTimeInSeconds: nullableNumber,
	uom: nullableString,
	siteName: nullableString,
});

export const rawDataResponseSchema = z.array(rawDataItemSchema);

export type RawDataItem = z.infer<typeof rawDataItemSchema>;

export const errorRawDataItemSchema = z.object({
	machineId: nullableStringToEmpty,
	machineAlias: nullableStringToEmpty,
	errorCode: nullableStringToEmpty,
	errorMessage: nullableStringToEmpty,
	errorArgs: nullableStringToEmpty,
	utcDateTime: nullableStringToEmpty,
	tenantId: nullableStringToEmpty,
	status: nullableStringToEmpty,
	primary: z
		.union([z.boolean()])
		.nullable()
		.default(null)
		.transform((val) => val ?? false),
});

export const errorRawDataResponseSchema = z.array(errorRawDataItemSchema);

export type ErrorRawData = z.infer<typeof errorRawDataItemSchema>;
